
<div class="redflags-logo" v-on="$listeners">
    <img :src="`${publicPath}datlab_logo.svg`"><div>KONTROLA</div>
</div>
